// extracted by mini-css-extract-plugin
module.exports = {"companyLogo":"Styles_companyLogo__CVSl1","thumbsUpIcon":"Styles_thumbsUpIcon__gBlTS"};